import { ChangeDetectionStrategy, Component, OnDestroy, ViewEncapsulation } from '@angular/core'
import { GbEventGuestScannerViewService, EventGuestScannerViewEnum } from './gb-event-guest-scanner-view.service'

@Component({
  selector: 'gb-event-guest-scanner-dialog',
  templateUrl: './gb-event-guest-scanner-dialog.component.html',
  styleUrls: ['./gb-event-guest-scanner-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class GbEventGuestScannerDialogComponent implements OnDestroy {
  viewShowing$ = this.eventGuestScannerViewService.viewShowing$
  EventGuestScannerViewEnum = EventGuestScannerViewEnum

  constructor(private eventGuestScannerViewService: GbEventGuestScannerViewService) {}

  ngOnDestroy(): void {
    this.eventGuestScannerViewService.resetViewShowing()
  }
}
